module.exports = __webpack_public_path__ + "app/principal/companies-details-1aKg2-R2.html";